import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=77418f7a&scoped=true"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"
import style0 from "./Scores.vue?vue&type=style&index=0&id=77418f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77418f7a",
  null
  
)

export default component.exports